// Liste complète des centres d'intérêt (50+)
export const INTERESTS_FR = [
  // Loisirs & Divertissement
  "Voyages", "Musique", "Cinéma", "Lecture", "Netflix", "Concerts", "Théâtre", 
  "Jeux vidéo", "Jeux de société", "Escape games", "Karaoké", "Festivals",
  
  // Sport & Fitness
  "Sport", "Yoga", "Fitness", "Running", "Natation", "Tennis", "Football", 
  "Randonnée", "Vélo", "Escalade", "Ski", "Danse", "Musculation", "Boxe",
  
  // Art & Créativité
  "Art", "Photographie", "Peinture", "Dessin", "Écriture", "Musique (jouer)",
  "DIY", "Décoration", "Mode", "Design",
  
  // Gastronomie
  "Cuisine", "Pâtisserie", "Restaurants", "Vin", "Cocktails", "Café",
  "Brunch", "Street food", "Cuisine du monde",
  
  // Nature & Animaux
  "Nature", "Animaux", "Jardinage", "Camping", "Plage", "Montagne",
  
  // Social & Lifestyle
  "Sorties", "Brunch entre amis", "Soirées", "Networking", "Bénévolat",
  
  // Culture & Apprentissage
  "Langues", "Histoire", "Sciences", "Podcasts", "Documentaires",
  
  // Tech & Geek
  "Tech", "Startups", "Crypto", "Gaming", "Manga/Anime", "Comics",
  
  // Bien-être
  "Méditation", "Développement personnel", "Spa", "Bien-être"
];

export const INTERESTS_EN = [
  // Leisure & Entertainment
  "Travel", "Music", "Movies", "Reading", "Netflix", "Concerts", "Theater",
  "Video games", "Board games", "Escape rooms", "Karaoke", "Festivals",
  
  // Sport & Fitness
  "Sports", "Yoga", "Fitness", "Running", "Swimming", "Tennis", "Football",
  "Hiking", "Cycling", "Climbing", "Skiing", "Dancing", "Gym", "Boxing",
  
  // Art & Creativity
  "Art", "Photography", "Painting", "Drawing", "Writing", "Playing music",
  "DIY", "Interior design", "Fashion", "Design",
  
  // Food & Drinks
  "Cooking", "Baking", "Restaurants", "Wine", "Cocktails", "Coffee",
  "Brunch", "Street food", "World cuisine",
  
  // Nature & Animals
  "Nature", "Pets", "Gardening", "Camping", "Beach", "Mountains",
  
  // Social & Lifestyle
  "Going out", "Brunch with friends", "Parties", "Networking", "Volunteering",
  
  // Culture & Learning
  "Languages", "History", "Science", "Podcasts", "Documentaries",
  
  // Tech & Geek
  "Tech", "Startups", "Crypto", "Gaming", "Manga/Anime", "Comics",
  
  // Wellness
  "Meditation", "Self-improvement", "Spa", "Wellness"
];

export const getInterests = (language = 'fr') => {
  return language === 'fr' ? INTERESTS_FR : INTERESTS_EN;
};
